"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var base_action_1 = require("./base.action");
var EnableButtonAction = /** @class */ (function (_super) {
    __extends(EnableButtonAction, _super);
    function EnableButtonAction(notificationService) {
        var _this = _super.call(this) || this;
        _this.notificationService = notificationService;
        return _this;
    }
    EnableButtonAction.prototype.act = function () {
        console.warn('Chat button enable / disable functionality has been deprecated. Please remove any related code from chat snippet.');
    };
    return EnableButtonAction;
}(base_action_1.BaseAction));
exports.EnableButtonAction = EnableButtonAction;
